import type { Easing, Transition, Variants } from "framer-motion";

import { useReducedMotion } from "framer-motion";

const DEFAULT_EASE: Easing = [0.16, 1, 0.3, 1];

const createTransition = (duration: number): Transition => ({
  duration,
  ease: DEFAULT_EASE,
});

export const createFadeInUp = (
  shouldReduceMotion: boolean,
  distance = 12,
  duration = 0.2,
): Variants => ({
  hidden: {
    opacity: 0,
    y: shouldReduceMotion ? 0 : distance,
  },
  show: {
    opacity: 1,
    y: 0,
    transition: createTransition(shouldReduceMotion ? 0 : duration),
  },
});

export const createStaggerContainer = (
  shouldReduceMotion: boolean,
  stagger = 0.06,
  delay = 0.04,
): Variants => ({
  hidden: {},
  show: {
    transition: {
      staggerChildren: shouldReduceMotion ? 0 : stagger,
      delayChildren: shouldReduceMotion ? 0 : delay,
    },
  },
});

export const getHoverLift = (shouldReduceMotion: boolean) =>
  shouldReduceMotion
    ? {}
    : {
        y: -4,
        boxShadow: "0 16px 30px rgba(0,0,0,0.12)",
      };

export const getTapScale = (shouldReduceMotion: boolean) =>
  shouldReduceMotion ? {} : { scale: 0.98 };

export const useMotionPreferences = () => {
  const shouldReduceMotion = useReducedMotion() ?? false;

  return {
    shouldReduceMotion,
    fadeInUp: createFadeInUp(shouldReduceMotion),
    pageTransition: createFadeInUp(shouldReduceMotion, 8, 0.22),
    staggerContainer: createStaggerContainer(shouldReduceMotion),
    hoverLift: getHoverLift(shouldReduceMotion),
    tapScale: getTapScale(shouldReduceMotion),
  };
};
